import { Tabs } from '../../../components/primitives';
import type { CalendarView } from '../../../types/calendar';

interface CalendarViewSwitcherProps {
  view: CalendarView;
  onChange: (view: CalendarView) => void;
}

const VIEW_TABS: Array<{ key: CalendarView; label: string }> = [
  { key: 'month', label: 'Month' },
  { key: 'week', label: 'Week' },
  { key: 'day', label: 'Day' },
  { key: 'agenda', label: 'Agenda' },
];

// A thin, calendar-specific wrapper around the existing `Tabs` primitive
// (variant="segment", already reused by BoardViewToggle) rather than a new
// segmented-control component — Tabs already gives keyboard reachability,
// accessibilityRole="tablist"/"tab" and accessibilityState.selected for free.
export function CalendarViewSwitcher({ view, onChange }: Readonly<CalendarViewSwitcherProps>) {
  return (
    <Tabs
      testID="calendar_view_switcher"
      tabs={VIEW_TABS}
      activeTab={view}
      onChange={(key) => onChange(key as CalendarView)}
      variant="segment"
    />
  );
}
